import { Link } from "react-router-dom";
import { ShieldCheck, Heart, Sparkles, Stethoscope, ArrowRight } from "lucide-react";

const SENIOR = "https://images.unsplash.com/photo-1543201245-c9031909fe6f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxzZW5pb3IlMjBjYXQlMjBzbGVlcGluZ3xlbnwwfHx8fDE3ODI3MDYwNDh8MA&ixlib=rb-4.1.0&q=85";

export default function About() {
  const values = [
    { icon: Stethoscope, t: "Veterinary Reviewed", d: "Every product is checked by our vet advisors for safety and relevance to senior and chronic-condition cats." },
    { icon: Sparkles, t: "Curated, Not Cluttered", d: "We carry only what works. No overwhelming aisles — just trusted solutions to real problems." },
    { icon: Heart, t: "Built on Empathy", d: "We understand the emotional weight of caring for an aging or sick cat. We're here for the hard days." },
    { icon: ShieldCheck, t: "Alongside Your Vet", d: "We're the organizational layer around veterinary care — never a replacement for it." },
  ];

  return (
    <div>
      <section className="bg-[#F8F9FA] py-20">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <span className="text-[#FF5C28] font-bold text-sm uppercase tracking-wide">Our story</span>
          <h1 className="font-display font-black text-4xl md:text-6xl tracking-tighter mt-3 mb-6">Care for the cat<br />who needs you most.</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Meow Care Love began with a simple frustration: the pet industry is flooded with general products, but almost nothing for the owners facing real, recurring problems — giving medication, managing hydration, easing senior mobility, and recovering litter-box habits. We curate only the best products on the internet for our loves — the cats who need us most.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 grid lg:grid-cols-2 gap-12 items-center">
        <img src={SENIOR} alt="Senior cat" className="rounded-3xl w-full object-cover aspect-[4/3]" />
        <div>
          <h2 className="font-display font-extrabold text-3xl md:text-4xl tracking-tight mb-6">For senior cats & chronic conditions</h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            Our primary focus is owners of senior cats and cats living with chronic conditions — the people managing daily challenges like difficult dosing, poor hydration, reduced appetite, accidents, and limited mobility.
          </p>
          <p className="text-gray-600 leading-relaxed mb-6">
            We organize the right products into five problem-based collections, pair them with practical guidance, and back it with veterinary review — so you can spend less time searching and more time caring.
          </p>
          <Link to="/shop" className="inline-flex items-center gap-2 rounded-full bg-[#FF5C28] text-white font-bold px-8 py-4 hover:bg-[#E04D1E] transition-colors">
            Explore Collections <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>

      <section className="bg-[#0F0F0F] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-extrabold text-3xl md:text-4xl tracking-tight text-center mb-12">What we stand for</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {values.map((v) => (
              <div key={v.t} className="bg-white/5 border border-white/10 rounded-3xl p-6">
                <div className="w-12 h-12 rounded-2xl bg-[#FF5C28] flex items-center justify-center mb-4">
                  <v.icon className="w-6 h-6 text-white" strokeWidth={2.5} />
                </div>
                <h3 className="font-display font-bold text-lg mb-2">{v.t}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
